var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
var Code = function (props) { return (React.createElement("svg", __assign({ viewBox: "0 0 970.94 768.02", width: "1em", height: "1em" }, props),
    React.createElement("defs", null),
    React.createElement("g", { id: "Layer_2", "data-name": "Layer 2" },
        React.createElement("g", { id: "icon" },
            React.createElement("path", { className: "cls-1", d: "M252.12 182.64a32 32 0 0 0-45.26-45.26L28.12 316.13a96 96 0 0 0 0 135.76l178.74 178.75a32 32 0 0 0 45.26-45.26L73.37 406.64a32.05 32.05 0 0 1 0-45.26zM942.86 316.13L764.12 137.38a32 32 0 0 0-45.26 45.26l178.75 178.74a32 32 0 0 1 0 45.26L718.86 585.38a32 32 0 0 0 45.26 45.26l178.74-178.75a96.1 96.1 0 0 0 0-135.76zM624.43 1.94a32 32 0 0 0-41 19.13l-256 704a32 32 0 1 0 60.14 21.87l256-704a32 32 0 0 0-19.14-41z" }))))); };
export default Code;
//# sourceMappingURL=Code.js.map